import { PATH_TO_CANCEL_FAST_STOCK_LOADING } from '../constants'

export const savePathToCancelFastStockLoading = path => (dispatch) => {
    dispatch({
      type: PATH_TO_CANCEL_FAST_STOCK_LOADING,
      data: path,
    })
  }